import { DocumentFilesInputFilters } from "domain/models/document-files-input-filter";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { DocumentFiles } from "domain/entities/document-files";
import { IDocumentFilesRepository } from "domain/contracts/document-files.contracts";
import {
  DocumentFilesPayload,
  UpdateInput,
} from "domain/entities/document-files";

class DocumentFilesRepository implements IDocumentFilesRepository {
  async getAll(
    filter: DocumentFilesInputFilters,
  ): Promise<Message<DocumentFiles[]>> {
    const response = await httpClient.get(`/documentFiles`, {
      params: filter,
    });
    return response.data;
  }
  async getById(id: string): Promise<Message<DocumentFiles>> {
    const response = await httpClient.get(`/documentFiles/${id}`);
    return response.data;
  }
  async create(
    input: DocumentFilesPayload,
  ): Promise<Message<DocumentFiles>> {
    const response = await httpClient.post(`/documentFiles`, {
      data: input,
    });
    return response.data;
  }
  async delete(id: string): Promise<Message<Boolean>> {
    const response = await httpClient.delete(`/documentFiles/${id}`);
    return response.data;
  }
  async update(input: UpdateInput): Promise<Message<boolean>> {
    const response = await httpClient.put(`/documentFiles/${input.id}`, {
      data: input,
    });
    return response.data;
  }
}

export default new DocumentFilesRepository();